import { defaultSolutionColor } from "@smartsuite/types";
import { fabric } from "fabric";

export class Spinner extends fabric.Object {
  spinnerAngle: number = 0;
  private readonly rotationDuration: number;
  private animationFrameId?: number;

  constructor(rotationDuration: number = 0.833) {
    super({ selectable: false, evented: false });
    this.rotationDuration = rotationDuration;
  }

  startAnimation(): void {
    this.stopAnimation();

    const FPS = 60;
    const rotationPerFrame = 360 / (this.rotationDuration * FPS);
    const animate = (): void => {
      this.spinnerAngle = (this.spinnerAngle + rotationPerFrame) % 360;
      this.canvas?.requestRenderAll();
      this.animationFrameId = requestAnimationFrame(animate);
    };
    this.animationFrameId = requestAnimationFrame(animate);
  }

  stopAnimation(): void {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = undefined;
    }
    this.spinnerAngle = 0;
  }

  _render(ctx: CanvasRenderingContext2D): void {
    ctx.save();
    const { width = 1, height = 1 } = this;
    ctx.rotate((this.spinnerAngle * Math.PI) / 180);

    const color = this.canvas
      ? getComputedStyle(this.canvas.getElement())
          .getPropertyValue("--solution-primary-color")
          .trim()
      : defaultSolutionColor.primary;

    const maxSize = Math.min(width, height) / 2;
    const radius = Math.max(3, Math.min(maxSize / 2, 20));
    const startAngle = 0;
    const endAngle = Math.PI * 1.5;

    ctx.beginPath();
    ctx.arc(0, 0, radius, startAngle, endAngle);
    ctx.lineWidth = 5;
    ctx.strokeStyle = color;
    ctx.stroke();
    ctx.closePath();

    ctx.restore();
  }
}
